module.exports = __webpack_public_path__ + "img/45.0445926.png";